export default {
  forgot_password_submit: {
    title: 'Restablecer contraseña',
    submit_complete: 'Enviado correctamente',
    password_reset: 'Se ha restablecido la contraseña',
  },
}
